import { transition } from "@codesandbox/states";

import type { State, Action } from "./types";

export const reducer = (prevState: State, action: Action) =>
  transition(prevState, action, {
    LOADING: {
      "MONACO_EDITOR:LIBRARY_LOADED": () => ({
        state: "READY",
      }),
      "MONACO_EDITOR:LIBRARY_ERROR": (_, { error }) => ({
        state: "ERROR",
        context: {
          event: "MONACO_EDITOR:LIBRARY_ERROR",
          state: "LOADING",
        },
        error: error,
      }),
    },
    READY: {},
    ERROR: {},
  });
